export default "__VITE_ASSET__e3cfe257__"